module.exports = __webpack_public_path__ + "img/77.afd6f553.webp";